import { motion } from "framer-motion";
import { useState } from "react";

const ease = [0.16, 1, 0.3, 1];

const QUOTES = [
  {
    text: "We asked Chic Photography to be our wedding photographers and I'm so glad we did. From the very beginning Andy was so helpful and made me feel at ease that we were choosing the right package. During the day Andy gave us directions of where to stand and how to pose, and the pictures turned out amazing. Him and his team did a superb job, and I can cherish our wedding day forever with the photos they took.",
    name: "Demi Smith",
    place: "Chic Wedding Couple",
  },
  {
    text: "I cannot express how happy me and my husband are with our whole experience with Andy and the team. They were so chilled, making us feel relaxed on the day and answered any questions we had with more than enough detail. We will be forever grateful for the moments and memories the team captured and couldn't thank them enough.",
    name: "Paige Haydon",
    place: "Chic Wedding Couple",
  },
  {
    text: "Chic Wedding Photography was an amazing find. Andy and his team really got to understand our vision and worked with us to ensure we were prepared ahead of the wedding. The quality of photos were excellent and so was the service and care given to us throughout the day. We can't think of a single special moment they missed and we now have a record of such wonderful memories with our friends and family.",
    name: "Jasmine Archer",
    place: "Chic Wedding Couple",
  },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  const q = QUOTES[i];

  return (
    <section
      data-testid="testimonials-section"
      className="relative px-6 md:px-12 lg:px-24 py-20 md:py-28 bg-[#1A1A1A] text-[#F6F1E8]"
    >
      <div className="grid grid-cols-1 gap-8 md:grid-cols-12 md:gap-10 items-start">
        <div className="md:col-span-3">
          <p className="eyebrow opacity-60 mb-4 hidden">Words From Our Couples</p>
          <p className="font-serif-display italic text-2xl md:text-3xl tracking-tight">
            On record.
          </p>
        </div>

        <motion.blockquote
          key={i}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease }}
          className="md:col-span-9"
        >
          <p
            data-testid="testimonial-quote"
            className="font-serif-display text-2xl sm:text-3xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
          >
            <span className="italic opacity-60">“</span>
            {q.text}
            <span className="italic opacity-60">”</span>
          </p>
          <div className="mt-10 md:mt-14 flex items-end justify-between flex-wrap gap-6">
            <div>
              <p className="eyebrow opacity-80">{q.name}</p>
              <p className="mt-2 text-sm opacity-60">{q.place}</p>
            </div>
            <div className="flex items-center gap-3">
              {QUOTES.map((_, idx) => (
                <button
                  key={idx}
                  data-testid={`testimonial-dot-${idx}`}
                  onClick={() => setI(idx)}
                  aria-label={`Quote ${idx + 1}`}
                  className={`h-px transition-all ${
                    idx === i ? "w-12 bg-[#F6F1E8]" : "w-6 bg-[#F6F1E8]/30"
                  }`}
                />
              ))}
              <button
                data-testid="testimonial-next"
                onClick={() => setI((i + 1) % QUOTES.length)}
                className="ml-4 eyebrow opacity-80 link-underline"
              >
                Next →
              </button>
            </div>
          </div>
        </motion.blockquote>
      </div>
    </section>
  );
}
